import {createSlice} from '@reduxjs/toolkit';
import {marketConfig} from "../../config/markets";
import {getEIMFromMSC} from "../../helpers/financialProductConfigurationHelpers";

export const appSlice = createSlice({
    name: 'app',
    initialState: {
        config: null,
        //input: null,
        touchpointConfig: null,
        modelsRatesMapping: null,
        rates: null,
        isFormLayerVisible: false
    },
    reducers: {

        setAppConfig(state, action) {
            state.config = {
                ...action.payload,
                marketConfig: marketConfig(action.payload.marketCode)
            };
        },

        setAppInput(state, action) {

            state.input = action.payload ? {
                ...action.payload,
                EIM: getEIMFromMSC(action.payload.EIM)
            } : null;
        },

        setTouchpointConfig(state, action) {
            state.touchpointConfig = action.payload;
        },

        setModelsRatesMapping(state, action) {
            state.modelsRatesMapping = action.payload;
        },

        setRates(state, action) {
            state.rates = action.payload;
        },

        setIsFormLayerVisible(state, action) {
            state.isFormLayerVisible = action.payload;
        },

        updateCookies(state, action) {
            state.config.cookies = {
                ...state.config.cookies,
                ...action.payload
            };
        }
    },
});

export const getAppData = state => state.app;

export const getAppConfig = state => state.app.config;
export const getAppInput = state => state.app.input;
export const getTouchpointConfig = state => state.app.touchpointConfig;
export const getModelsRatesMapping = state => state.app.modelsRatesMapping;
export const getRates = state => state.app.rates;
export const getIsFormLayerVisible = state => state.app.isFormLayerVisible;

export const {
    setAppConfig,
    setAppInput,
    setTouchpointConfig,
    setModelsRatesMapping,
    setRates,
    setIsFormLayerVisible,
    updateCookies
} = appSlice.actions;

export default appSlice.reducer;
